import { Tab } from "@mui/material";
import { EQUIPMENT_TAB_INDEX } from "..";

interface EquipmentTab {
    label: string;
    value: EQUIPMENT_TAB_INDEX;
}

const EquipmentTab = (props: EquipmentTab) => {
    const { label, value } = props;
    return (
        <Tab
            {...props}
            sx={{
                fontSize: '18px',
                fontFamily: 'Roboto, sans-serif',
                flex: 1,
                textAlign: 'left'
            }}
            label={label}
            value={value}
        />
    );
};

export { EquipmentTab };